<template>
	<div>
		<div class="chenggao"></div>
		<div id="topimg" v-show="this.topHide" v-if="this.$route.path == '/'"><a :href="this.toplink" target="_blank"><img :src="icoURL+'storage/'+this.topimg" alt=""></a></div>
		<div id="header">
			<div class="header-1">
				<div class="container">
					您好！欢迎访问{{this.settingObj.title}}官网
				</div>
			</div>
			<div class="header-2">
				<div class="container">
					<div class="logo fl" @click="logoIndex()">
						<!-- <img src="/images/logo.png" alt=""> -->
						<img :src="icoURL+'storage/'+settingObj.logo" alt="">
					</div>
					<div class="nav fr">
						<ul class="list-unstyled">
							<li v-for="(item,index) in this.menus" :class="{ cur : item.id == hcurIDprop }"  :id='`li-${item.id}`' @mouseenter="li_fun(item.id)" @mouseleave="li_funx(item.id)">
								<div class="nav_a" @click="navTo(item,index)">
									<img :src="icoURL+'storage/'+item.icon" alt="">
									{{item.name}}
								</div>
								<ul class="list-unstyled"  v-if="item.child.length > 0 && item.id != 2">
									<li v-for="(itemx,indexx) in item.child"><div class="nav_ax" @click="navTo(item,itemx,index)">{{itemx.name}}</div></li>
								</ul>
							</li>		
						</ul>
						<div class="clear"></div>
					</div>
					<div class="clear"></div>
				</div>
			</div>
		</div>
		<div id="header-2">
			<div class="logo-2 fl" @click="logoIndex()">
				<!-- <img src="/images/logo.png" alt=""> -->
				<img :src="icoURL+'storage/'+settingObj.logo" alt="">
			</div>
			<div class="menu2 fr">
				<ul class="list-unstyled">
					<li><a id="sanlan"><img src="../assets/images/sanlan.png" alt=""></a></li>
				</ul>
				<div class="clear"></div>
			</div>
			<div class="clear"></div>
			<div class="nav-2">
				<ul class="list-unstyled">
				<!--<li><a href="#">公司概况</a>
						<span class="jiaspan"></span>
						<ul class="list-unstyled">
							<li><a href="#">二级栏目</a></li>
							<li><a href="#">二级栏目</a></li>
							<li><a href="#">二级栏目</a></li>
							<li><a href="#">二级栏目</a></li>
						</ul>
					</li> -->
					<li v-for="(item,index) in this.menus">
						<div class="nav_ax" @click="navTo(item,index)">{{item.name}}</div>
						<template v-if="item.child">
							<span :id='`jiaspan-${item.id}`' class="jiaspan" @click="jiaspan_fun(item.id)"></span>
							<ul class="list-unstyled">
								<li v-for="itemx in item.child">
									<div class="nav_axx" @click="navTo(item,itemx,index)">{{itemx.name}}</div>
								</li>
							</ul>
						</template>
					</li>
				</ul>
			</div>
		</div>
		<div id="nav-2-heidi"></div>
	</div>
</template>

<script>
	export default {
	  name: 'hHeader',
		props:['hcurID'],
		data() {
			return {
				htmlTitle:'',
				menus:[],
				activeIndex:'',
				hcurIDprop:'',
				setting:[],
				settingObj:{
					logo:'',
					title:'',
					description:'',
					keywords:''
				},
				topimg:'',
				toplink:'',
				topHide:true
			}
		},
		methods:{
			res_siteInfo(){
				this.axios.get('/api/setting')
					.then(response => {
						// 处理成功情况
						if(response.data.code == 200){
							this.setting = response.data.reslut;
							this.setting.forEach(item=>{
								if(item.key == "admin.logo"){
									this.settingObj.logo = item.value;
								}
								if(item.key == "admin.title"){
									this.settingObj.title = item.value;
								}
								if(item.key == "admin.description"){
									this.settingObj.description = item.value;
								}
								if(item.key == "admin.keywords"){
									this.settingObj.keywords = item.value;
								}
								if(item.key == "default.zt_image"){
									this.topimg = item.value;
									var that = this
									setTimeout(function() {
									   that.topHide = false
									}, 5000);
								}
								if(item.key == "default.zt_link"){
									this.toplink = item.value;
								}
							})

							if(this.settingObj.keywords != ''){
								$("meta[name='Keywords']").eq(0).attr("content",this.settingObj.keywords)
							}
							if(this.settingObj.description != ''){
								$("meta[name='Description']").eq(0).attr("content",this.settingObj.description)
							}		
							this.res_menuClass(this.hcurIDprop);
						}
					})
					.catch(error => {
						// 处理错误情况
						console.log(error);
					})
			},
			res_menu(){
				this.axios.get('/api/menus')
					.then(response => {
						// 处理成功情况
						console.log('栏目查询:',response);
						if(response.data.code == 200){
							this.menus = response.data.reslut;
						}
						
					})
					.catch(error => {
						// 处理错误情况
						console.log(error);
					})
				
			},
			res_menuClass(e){
				this.axios.get('/api/menus/class?id='+e)
					.then(response => {
						// 处理成功情况
						if(response.data.code == 200){
							if(this.settingObj.title != ''){
								document.title = response.data.reslut.name + '-' + this.settingObj.title;
							}
						}
						
					})
					.catch(error => {
						// 处理错误情况
						console.log(error);
					})
				
			},
			logoIndex(){
				this.$router.push('/');
				$("#nav-2-heidi").fadeOut();
				$(".nav-2>ul>li>ul").slideUp();
				$(".nav-2").slideUp();
			},
			phoneMenu(){
				$("#nav-2-heidi").fadeOut();
				$(".nav-2>ul>li>ul").slideUp();
				$(".nav-2").slideUp();
				$(".nav>ul>li>ul").hide();
			},
			li_fun(e){
				let id = `li-${e}`;
				let dom = $(`#${id}`);
				dom.find("ul").stop(false,true).slideDown();
			},
			li_funx(e){
				let id = `li-${e}`;
				let dom = $(`#${id}`);
				dom.find("ul").stop(false,true).hide();
			},
			jiaspan_fun(e){
				let id = `jiaspan-${e}`;
				var dom = $(`#${id}`);
				if(dom.hasClass("cur")){
					dom.removeClass("cur");
					$(".nav-2>ul>li>ul").slideUp();
				}else{
					$(".jiaspan").removeClass("cur");
					dom.addClass("cur");
					$(".nav-2>ul>li>ul").slideUp();
					dom.next(".nav-2>ul>li>ul").slideDown();
				}
			},
			navTo(item,itemx,index){
					this.phoneMenu();
					this.navFun(item,itemx,index);
					if(item.id != 7 && itemx.id != 26){
						this.hcurIDprop = item.id;
					}
			},
			navFun(item,itemx,index){
				
				if(item.name == '网站首页'){
					this.$router.push({
						path:'/',
					})
				}	
				
				
				if(item.name == '新闻动态'){
					if(itemx.id){
						//点击二级栏目
						this.$router.push({
							path: this.$route.path.search('slider') == -1 ?  'slider/' + item.id+ '/elist' : this.$route.path.slice(0,8)  + item.id+ '/elist',
							query:{
								category_id:itemx.id,
							}
						})
					}else{
						//点击一级栏目
						this.$router.push({
							path:item.url,
							query:{
								category_id:item.id,
							}
						})
					}
					
				}		

				if(item.name == '机构设置'){
					if(itemx.id){
						if(itemx.name=='领导机构'){
							this.$router.push({
								path:item.url + '/' + item.id + '/organ',
								query:{
									category_id:itemx.id,
								}
							})
						}else{
							this.$router.push({
								path:item.url + '/' + item.id + '/contentt',
								query:{
									category_id:itemx.id,
								}
							})
						}
					}else{
						this.$router.push({
							path:item.url + '/' + item.id + '/contentt',
							query:{
								category_id:item.child[0].id
							}
						})
					}
				}
				
				if(item.name == '党的建设'){
					if(itemx.id){
						//点击二级栏目
						this.$router.push({
							path: this.$route.path.search('slider') == -1 ?  'slider/' + item.id+ '/elist' : this.$route.path.slice(0,8)  + item.id+ '/elist',
							query:{
								category_id:itemx.id,
							}
						})
					}else{
						//点击一级栏目
						this.$router.push({
							path: this.$route.path.search('slider') == -1 ?  'slider/' + item.id+ '/elist' : this.$route.path.slice(0,8)  + item.id+ '/elist',
							query:{
								category_id:item.child[0].id
							}
						})
					}
				}
				
				if(item.name == '重点工作'){
					if(itemx.id){
						//点击二级栏目
						this.$router.push({
							path: this.$route.path.search('slider') == -1 ?  'slider/' + item.id+ '/elist' : this.$route.path.slice(0,8)  + item.id+ '/elist',
							
							query:{
								category_id:itemx.id,
							}
						})
					}else{
						//点击一级栏目
						this.$router.push({
							path:item.url,
							query:{
								category_id:item.id,
							}
						})
					}
					
				}		
				
				
				if(item.name == '办事服务'){
					if(itemx.id){
						//点击二级栏目
						window.open(itemx.url);
					}else{
						//点击一级栏目
						this.$router.push({
							path:item.url,
							query:{
								category_id:item.id,
							}
						})
					}
					
				}		
				
				if(item.name == '专题专栏'){
					
					/*  专题专栏子栏目跳转别的栏目
					
					if(itemx.id){
						//点击二级栏目
						this.$router.push({
							path: this.$route.path.search('slider') == -1 ?  'slider/' + item.id+ '/elist' : this.$route.path.slice(0,8)  + item.id+ '/elist',
							query:{
								category_id:itemx.id,
							}
						})
					}else{
						//点击一级栏目
						this.$router.push({
							path: this.$route.path.search('slider') == -1 ?  'slider/' + item.id+ '/elist' : this.$route.path.slice(0,8)  + item.id+ '/elist',
							query:{
								category_id:item.child[0].id
							}
						})
					}
					
					*/
					
					
					
					
					if(itemx.id){
						//点击二级栏目
						// this.$router.push({
						// 	path: this.$route.path.search('slider') == -1 ?  'slider/' + 4 + itemx.url : this.$route.path.slice(0,8)  + 4 + itemx.url
						// })
						//跳转外部链接
						window.open(itemx.url)
					}
					// else{
					// 	//点击一级栏目
					// 	this.$router.push({
					// 		path: this.$route.path.search('slider') == -1 ?  'slider/' + item.id+ '/elist' : this.$route.path.slice(0,8)  + item.id+ '/elist',
					// 		query:{
					// 			category_id:item.child[0].id
					// 		}
					// 	})
					// }
				}
			}
		},
		
		
		created() {
			this.hcurIDprop = this.hcurID;
			this.res_menu()
			this.res_siteInfo();
			
		},
		watch :{
			'hcurID' (to, from) {
					// 对路由变化作出响应...
					if(to.id != 7){
						this.hcurIDprop = this.hcurID;
						this.res_menuClass(this.hcurIDprop)
					}
			}
		},
		mounted(){
			$("#sanlan").click(function(){
				$("#nav-2-heidi").fadeToggle();
				$(".nav-2").slideToggle();
				$(".nav-2>ul>li>ul").slideUp();
				$(".jiaspan").removeClass("cur");
			})
			$("#nav-2-heidi").click(function(){
				$(this).fadeOut();
				$(".nav-2>ul>li>ul").slideUp();
				$(".nav-2").slideUp();
			})
			
			
		}
	}
</script>

<style>
	
</style>